import React, { PureComponent, createElement } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ButtonBase from '@material-ui/core/ButtonBase'
import Card from 'atoms/Card'
import CloseIcon from '@material-ui/icons/Close'

const createColorStyles = (theme, color, colorActive) => ({
  '& $button': {
    backgroundColor: theme.palette.common.white,
    color,
    '&:hover': {
      backgroundColor: color,
      color: theme.palette.common.white,
    },
    '&:active': {
      backgroundColor: colorActive,
      color: theme.palette.common.white,
    }
  },
  '& $deleteButton': {
    backgroundColor: colorActive,
    color: theme.palette.common.white,
  }
})

const styles = theme => ({
  root: {
    display: 'inline-block',
    position: 'relative',
  },
  button: {
    border: 0,
    width: '100%',
    height: '3rem',
    borderRadius: 8,
    margin: 0,
    padding: `0 ${theme.spacing.unit * 2}px`,
    cursor: 'pointer',
    outline: 0,
    transition: theme.transitions.create(['background-color', 'color']),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonChildren: {},
  buttonWithIcon: {
    '& $buttonChildren': {
      marginLeft: theme.spacing.unit,
    }
  },
  deleteButton: {
    position: 'absolute',
    top: -theme.spacing.unit * 1.5,
    right: -theme.spacing.unit * 1.5,
    width: theme.spacing.unit * 3,
    height: theme.spacing.unit * 3,
  },
  deleteButtonIcon: {
    width: theme.spacing.unit * 2,
    height: theme.spacing.unit * 2,
  },
  'color-default': createColorStyles(theme, theme.palette.secondary.light, theme.palette.secondary.main),
  'color-purple': createColorStyles(theme, '#B837A2', '#9F2F8C'),
  'color-violet': createColorStyles(theme, '#352384', '#2D1D73'),
  'color-cyan': createColorStyles(theme, '#1DABB5', '#198E96'),
  'color-blue': createColorStyles(theme, '#67B4FF', '#74a4d3'),
  'color-black': createColorStyles(theme, '#363638', '#242426'),
})

const CardWithComponent = ({ cardComponent, ...rest }) => (
  <Card component={cardComponent} {...rest} />
)

CardWithComponent.propTypes = {
  cardComponent: PropTypes.any,
}

export default
@withStyles(styles)
class Button extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    classes: PropTypes.object.isRequired,
    type: PropTypes.string,
    icon: PropTypes.any,
    className: PropTypes.any,
    color: PropTypes.oneOf(['default', 'purple', 'violet', 'cyan', 'blue', 'black']),
    onDelete: PropTypes.func,
    component: PropTypes.any,
  }

  static defaultProps = {
    type: 'button',
    color: 'default'
  }

  renderButton() {
    const { classes, children, icon, className, color, onDelete, component, ...rest } = this.props
    const cx = classNames(classes.button, {
      [classes.buttonWithIcon]: !!icon
    })
    return (
      <ButtonBase
        {...rest}
        component={CardWithComponent}
        cardComponent={component}
        className={cx}
        tabIndex="-1"
      >
        { !!icon && createElement(icon) }
        <Typography
          color="inherit"
          variant="caption"
          className={classes.buttonChildren}
        >
          { children }
        </Typography>
      </ButtonBase>
    )
  }

  renderDeleteButton() {
    const { classes, onDelete } = this.props
    return !!onDelete && (
      <IconButton className={classes.deleteButton} onClick={onDelete} tabIndex="-1">
        <CloseIcon className={classes.deleteButtonIcon} />
      </IconButton>
    )
  }

  render() {
    const { classes, className, color } = this.props
    const cx = classNames(classes.root, className, classes[`color-${color}`])
    return (
      <div className={cx}>
        { this.renderButton() }
        { this.renderDeleteButton() }
      </div>
    )
  }
}
